module.exports = __webpack_public_path__ + "img/spartan-logo-web_1.0d9503ca.svg";